import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-241" data-mp="2sk41z76p1a4p">
      <div className="mx-auto max-w-2xl border-2 border-red-500 bg-[#16161F] p-8 text-center sm:p-11" data-id="element-242" data-mp="36ahbvf35aywo">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-400" data-id="element-243" data-mp="31ipikwsluf2u">
          <Clock3Icon className="h-4 w-4" data-id="element-244" data-mp="3g72i23qwig23" /> Limited-time offer
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-245" data-mp="3b9apd7ifmpwu">
          Launch price ends in:
        </h2>
        <div className="my-9" data-id="element-246" data-mp="3p8a67szpe0ig">
          <CountdownTimer size="large" dark data-id="element-247" data-mp="3l78dlv0akmpg" />
        </div>
        <p className="font-semibold text-white" data-id="element-248" data-mp="3l7q7wm3e8quq">
          After that, the price goes up and bonuses are removed.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-249" data-mp="1uwvfb8uyhv14">
          <div className="h-3 overflow-hidden border border-red-500/50 bg-[#0A0A0A]" data-id="element-250" data-mp="1qtyxhkd8q2y8">
            <div className="h-full w-[72%] bg-red-500" data-id="element-251" data-mp="2su6cta14mhvv" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-252" data-mp="2xsr3oiuhnp7n">
            <span className="text-red-400" data-id="element-253" data-mp="32rubuc5rmbju">Limited spots</span>
            <span className="text-[#B0B0C0]" data-id="element-254" data-mp="32q9c884lg2f4">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}